<!-- menu -->
<div style="padding-top:5px;background-color:#ffffff;max-width:1400px;margin-left:auto;margin-right:auto;">
    <app-menu></app-menu>
</div>

<!-- header image -->
<div style="width:100%;margin:auto;background-color:#ffffff;">
    <img class="audi-header-image" src="assets/images/audi-header-img.png" alt="Audi Header Image" [hidden]="!headerImageVisible" />
</div>

<!-- main content -->
<div class="aui-container">
    <div class="aui-row">
        <div>
            <div>
                <app-audi-text variant="order3" weight="bold" text="{{headerText}}">
                </app-audi-text><br />
                <app-audi-text variant="order3" weight="bold" text="{{subHeaderText}}">
                </app-audi-text><br />
            </div>
            <div style="margin-left:-15px;">
                <p-tabView [(activeIndex)]="activeTabIndex">
                    <p-tabPanel header="01. Your Details" [disabled]="activeTabIndex!=0">
                    </p-tabPanel>
                    <p-tabPanel header="02. Select Your Plan" [disabled]="activeTabIndex!=1">
                    </p-tabPanel>
                    <p-tabPanel header="03. Purchase" [disabled]="activeTabIndex!=2" *ngIf="!justBrowsing">
                    </p-tabPanel>
                </p-tabView>
                <div style="margin-top:-20px;margin-left:15px;margin-right:15px;">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <!--modal for 'contact us'-->
        <jw-modal id="contact-us" headerText="Contact Us">
            <app-contact-us #contactUs></app-contact-us>
        </jw-modal>
        <!--dialog modal-->
        <app-dialog header="{{dialogHeader}}" message="{{dialogMessage}}" [(visible)]="dialogVisible" (closeDialog)="onCloseDialog()">
        </app-dialog>
        <!--contact us button-->
        <div class="contact-us-div">
            <app-audi-button text="Contact Us" (click)="onShowContactUsDialog()" class="contact-us-btn">
            </app-audi-button>
        </div>
    </div>
</div>

<!--loading spinner-->
<div [hidden]="!loaderVisible" style="position:fixed;top:40vh;left:0;right:0;margin-left:auto;margin-right:auto;z-index:12000;">
    <app-audi-loader></app-audi-loader>
</div>
<div [hidden]="!loaderVisible" style="background-color:black;opacity:0.25;position:fixed;z-index:1000;top:0;bottom:0;left:0;right:0;">
</div>

<!--footer-->
<app-footer></app-footer>

<!--modal for confirming app update-->
<p-dialog header="Update Available" [(visible)]="displayUpdateNotice" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p>
        A new version is available, do you want to update?
    </p>
    <ng-template pTemplate="footer">
        <app-audi-button (click)="onConfirmUpdate(false)" text="No"></app-audi-button>
        <app-audi-button (click)="onConfirmUpdate(true)" text="Yes"></app-audi-button>
    </ng-template>
</p-dialog>